import { render, staticRenderFns } from "./PricingGrid.vue?vue&type=template&id=63df674b&lang=pug"
import script from "./PricingGrid.vue?vue&type=script&lang=js"
export * from "./PricingGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports